// src/pages/beta-community/components/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="beta-footer">
      <div className="container">
        <p><strong>Artkiv</strong> — Gestion, valorisation et transmission des collections</p>
        <p className="footer-links">
          <a href="mailto:support@artkiv.com">support@artkiv.com</a>
          {' · '}
          <a href="https://artkiv.com" target="_blank" rel="noopener noreferrer">artkiv.com</a>
          {' · '}
          <a href="https://vision.artkiv.com" target="_blank" rel="noopener noreferrer">vision.artkiv.com</a>
        </p>
        <p className="footer-copyright">© 2026 Artkiv. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;